import React, { useState, useEffect, useCallback } from "react";
import { Tooltip } from "@mui/material";
import "./Tooltip.scss";

export default function AccessibleTooltip({ title, id, children, bottom, permant,  customclass = "" }) {
  const [open, setOpen] = useState(false);
  const [lastInteraction, setLastInteraction] = useState("mouse");
  const isDisabled = children?.props?.disabled;

  useEffect(() => {
    const setMouse = () => setLastInteraction("mouse");
    const setKeyboard = () => setLastInteraction("keyboard");

    window.addEventListener("mousedown", setMouse, true);
    window.addEventListener("pointerdown", setMouse, true);
    window.addEventListener("keydown", setKeyboard, true);

    return () => {
      window.removeEventListener("mousedown", setMouse, true);
      window.removeEventListener("pointerdown", setMouse, true);
      window.removeEventListener("keydown", setKeyboard, true);
    };
  }, []);

  const onWrapperKeyDown = useCallback((e) => {
    if (e.key === "Escape") {
      setOpen(false);
    }
  }, []);

  const onWrapperFocus = useCallback((e) => {
    const target = e.target;
    const focusVisible =
      typeof target.matches === "function" &&
      target.matches(":focus-visible");

    if (lastInteraction === "keyboard" || focusVisible) {
      setOpen(true);
    }
  }, [lastInteraction]);

  const onWrapperBlur = () => setOpen(false);

  const onWrapperMouseEnter = () => {
    setLastInteraction("mouse");
    setOpen(true);
  };
  const onWrapperMouseLeave = () => setOpen(false);

  const childAriaLabel =
    (children && children.props && children.props["aria-label"]) || title;

  return (
    <Tooltip
      title={isDisabled ? "" : title}
      id={id}
      role="tooltip"
      enterTouchDelay={0}
      leaveTouchDelay={3000}
      placement="top"
      disableInteractive
      classes={{ tooltip: `globalTooltip${bottom ? " bottomTooltip" : ""} ${customclass}` }}
      open={open} 
      onClose={() => setOpen(false)}
    >
      <span
        tabIndex={-1}
        aria-hidden={isDisabled}
        onFocus={onWrapperFocus}
        onBlur={onWrapperBlur}
        onMouseEnter={onWrapperMouseEnter}
        onMouseLeave={onWrapperMouseLeave}
        onKeyDown={onWrapperKeyDown}
      >
        {React.cloneElement(children, {
          "aria-label": childAriaLabel,
          onMouseDown: (e) => {
            setLastInteraction("mouse");
            if (typeof children.props.onMouseDown === "function") {
              children.props.onMouseDown(e);
            }
          },
          onKeyDown: (e) => {
            if (e.key === "Tab" || e.key === "Enter" || e.key === " ") {
              setLastInteraction("keyboard");
            }
            if (typeof children.props.onKeyDown === "function") {
              children.props.onKeyDown(e);
            }
          },
        })}
      </span>
    </Tooltip>
  );
}
